var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "奖金参数设置",
        visible: _vm.dialogVisible,
        width: "800px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: {
            "max-height": "50vh",
            "overflow-y": "auto",
            padding: "15px 30px",
            "min-height": "100px"
          }
        },
        [
          _vm.loaded && (_vm.hasParams || _vm.inited)
            ? [
                _vm._l(_vm.gradeList, function(item, index) {
                  return _c(
                    "el-row",
                    {
                      key: index,
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "align-items": "center",
                        "margin-top": "10px"
                      }
                    },
                    [
                      _c("div", [_vm._v(_vm._s(index + 1 + "、"))]),
                      _c("div", { staticStyle: { width: "100px" } }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _c(
                        "el-input",
                        {
                          staticStyle: {
                            width: "300px",
                            "margin-left": "20px"
                          },
                          attrs: { placeholder: "请输入对应的奖金金额" },
                          model: {
                            value: item.bonus,
                            callback: function($$v) {
                              _vm.$set(item, "bonus", $$v)
                            },
                            expression: "item.bonus"
                          }
                        },
                        [
                          _c("template", { slot: "prepend" }, [
                            _vm._v("奖金金额")
                          ]),
                          _c("template", { slot: "append" }, [_vm._v("元")])
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "el-row",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "align-items": "center",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.gradeList.length + 1 + "、"))
                    ]),
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("店铺奖励")
                    ]),
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "300px", "margin-left": "20px" },
                        attrs: { placeholder: "请输入店铺奖励金额" },
                        model: {
                          value: _vm.shopBonus,
                          callback: function($$v) {
                            _vm.shopBonus = $$v
                          },
                          expression: "shopBonus"
                        }
                      },
                      [
                        _c("template", { slot: "prepend" }, [
                          _vm._v("奖励金额")
                        ]),
                        _c("template", { slot: "append" }, [_vm._v("元")])
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            : _vm.loaded
            ? _c(
                "div",
                { staticStyle: { "text-align": "center", padding: "40px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#909399",
                        "font-size": "14px",
                        "margin-bottom": "15px"
                      }
                    },
                    [_vm._v("该产品暂未配置奖金参数")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onInit } },
                    [_vm._v("创建初始数据")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.hasParams
            ? _c(
                "el-button",
                {
                  staticStyle: { float: "left" },
                  attrs: { type: "danger" },
                  on: { click: _vm.clickDelete }
                },
                [_vm._v("删除配置")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _vm.hasParams || _vm.inited
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
                [_vm._v("提交")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }